// src/shared/hooks/useTheme.js
// ✅ Hook إدارة Light / Dark Mode
// الاستخدام: const { theme, toggleTheme, isDark } = useTheme();

import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'app-theme';
const DARK        = 'dark';
const LIGHT       = 'light';

/** يقرأ التفضيل من localStorage أولاً، ثم إعداد النظام */
const getInitialTheme = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === DARK || stored === LIGHT) return stored;
  } catch { /* localStorage غير متاح */ }

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? DARK
    : LIGHT;
};

const applyThemeToDOM = (theme) => {
  document.documentElement.setAttribute('data-theme', theme);
  try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* تجاهل */ }
};

const useTheme = () => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    applyThemeToDOM(theme);
  }, [theme]);

  /* الاستماع لتغييرات إعداد النظام (إذا لم يختر المستخدم يدوياً) */
  useEffect(() => {
    const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
    if (!mq) return;
    const handler = (e) => {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setTheme(e.matches ? DARK : LIGHT);
      }
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const toggleTheme = useCallback(
    () => setTheme((p) => (p === DARK ? LIGHT : DARK)),
    []
  );

  const setDark  = useCallback(() => setTheme(DARK),  []);
  const setLight = useCallback(() => setTheme(LIGHT), []);

  return { theme, isDark: theme === DARK, isLight: theme === LIGHT, toggleTheme, setDark, setLight };
};

export default useTheme;